import CompanyTypes from './CompanyTypes';
import DateRange from './DateRange';
import RoleSelect from './RoleSelect';
import SearchField from './SearchField';
import Select from './Select';
import Toggle from './Toggle';

const Filter = () => {
  return [];
};

Filter.Search = SearchField;
Filter.CompanyTypes = CompanyTypes;
Filter.DateRange = DateRange;
Filter.Toggle = Toggle;
Filter.RoleSelect = RoleSelect;
Filter.Select = Select;

export default Filter;
